<template>
  <div class="banner">
    <video :src="video" id="video1" style="width: 100%;margin-top: -90px;" muted autoplay loop />
    <div class="text">
      <Form
        v-if="showForm"
        @msg="msg => $emit('msg', msg)"
        @setShowSuccessDialog="setShowSuccessDialog"
        :landingPageName="landingPageName"
      />
      <div class="banner_tabbox">
        <div class="tab_listbox">
          <div :class="index % 2 === 0 ? 'list' : 'list_block'" v-for="(item, index) in list" :key="index">
            <div class="list_year">{{ item[0] }}<span class="list-plus" v-if="index < list.length - 1">+</span></div>
            <div class="list_con">{{ item[1] }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showForm: Boolean,
    list: Array,
    video: String,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  components: {
    Form: () => import('./Form.vue'),
  },
  methods: {
    closeform(e) {
      console.log(e)
    },
    setShowSuccessDialog(v) {
      this.$emit('setShowSuccessDialog', v)
    },
  },
}
</script>

<style lang="less" scoped>
.banner {
  height: 710px;
  position: relative;
  margin-top: -90px;
  overflow: hidden;
  width: 100%;

  video {
    object-fit: fill;
    min-height: 670px;
    z-index: -11;
    display: inline-block;
    vertical-align: baseline;
    width: 100%;
  }

  source {
    min-width: 100%;
    min-height: 670px;
    height: auto;
    width: auto;
  }

  .text {
    width: 100%;
    height: 620px;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 56px;
    top: 90px;
    z-index: 999;
    position: absolute;
    display: flex;
    justify-content: center;
  }
  .banner_tabbox {
    width: 100%;
    height: 80px;
    background: rgba(0, 0, 0, 0.8);
    position: absolute;
    bottom: 10px;
    color: #fff;
    text-align: center;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
  .tab_listbox {
    height: 80px;
    display: flex;

    .list {
      width: 240px;
      background: rgba(51, 51, 51, 0.6379);
      font-size: 20px;
      color: #fff;
      height: 80px;
      padding-top: 14px;

      .list_year {
        font-weight: 700;
      }

      .list_con {
        font-size: 20px;
      }
    }

    .list-plus {
      font-size: 16px;
      font-family: PingFangSC;
      font-weight: 500;
      color: #fff;
      line-height: 22px;
      position: relative;
      top: -10px;
    }

    .list_block {
      width: 240px;
      font-size: 20px;
      color: #fff;
      height: 80px;
      padding-top: 14px;

      .list_year {
        font-weight: 700;
      }
      .list_con {
        font-size: 20px;
      }
    }
  }
}
/deep/ .txt_box .toTry {
  margin-top: 93px !important;
}
</style>
